import React, { Component } from 'react';

class Social extends Component {
    render() {
        return (
            <div class="social">
            <div class="btnsame btn1">
				<a href="https://github.com/arunkbabu90" target="_blank"><i class="fa fa-github"></i></a>
			</div>
			<div class="btnsame btn3">
				<a href="https://www.linkedin.com/in/arunkbabu" target="_blank"><i class="fa fa-linkedin"></i></a>
			</div>
            </div>
            )
        }
    }
    
export default Social
    